/**
 * @fileoverview POST handler for the "/api/calculated_attributes/:app_group_id/reactivate" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postApiCalculatedAttributesAppGroupIdReactivateCacheKeys } from "./constants";
import type {
  PostApiCalculatedAttributesAppGroupIdReactivateProps,
  PostApiCalculatedAttributesAppGroupIdReactivateResult,
} from "./types";

// POST rather than the PATCH calculated filters uses -- see routes.rb.
export const postApiCalculatedAttributesAppGroupIdReactivate = reactQueryMutationAdapter(
  postApiCalculatedAttributesAppGroupIdReactivateCacheKeys,
  (
    props: PostApiCalculatedAttributesAppGroupIdReactivateProps
  ): Promise<PostApiCalculatedAttributesAppGroupIdReactivateResult> => {
    const { app_group_id: appGroupId, calculated_attribute_ids: calculatedAttributeIds } = props;
    return fetch(
      `/api/calculated_attributes/${appGroupId}/reactivate`,
      "POST",
      { calculated_attribute_ids: calculatedAttributeIds },
      undefined,
      { propagateFetchRequestError: false }
    );
  }
);
